import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editor", "counter"]

  connect() {
    this.updateWordCount()
    if (this.hasEditorTarget) {
      this.editorTarget.addEventListener("trix-change", this.updateWordCount.bind(this))
    }
  }

  disconnect() {
    if (this.hasEditorTarget) {
      this.editorTarget.removeEventListener("trix-change", this.updateWordCount.bind(this))
    }
  }

  updateWordCount() {
    if (!this.hasEditorTarget) {
      return
    }

    const text = this.editorTarget.editor.getDocument().toString().trim()
    const wordCount = text ? text.split(/\s+/).length : 0
    this.counterTarget.textContent = wordCount
  }
}
